var ValidationUtilities = /** @class */ (function () {
    function ValidationUtilities() {
    }
    /**
     * Indicates that validation errors should be shown. 'Required' validation is omitted.
     * @param {String[]} errors - array of error messages
     * @param {Object} failedRules - object with properties named after failed rules. Property value is the error message.
     */
    ValidationUtilities.enableValidationErrorOmitRequired = function (errors, failedRules) {
        var requiredFailed = (failedRules && failedRules.required != undefined);
        var errorTypeCount = failedRules ? Object.keys(failedRules).length : 0;
        var totalErrors = errors ? errors.length : 0;
        // 
        if (totalErrors == 0 || errorTypeCount == 1 && requiredFailed)
            return false;
        else
            return true;
    };
    /**
     * Indicates that validation errors should be shown. Given validations are omitted
     * @param {Object} failedRules - object with properties named after failed rules. Property value is the error message.
     * @param {String[]} omitted - array of omitted validation rules
     */
    ValidationUtilities.enableValidationErrorOmitDesired = function (failedRules, omitted) {
        if (failedRules == null) {
            return false;
        }
        else {
            var failedRuleNames = Object.keys(failedRules);
            if (failedRuleNames.length == 0) {
                return false;
            }
            else {
                var effectiveFailedRuleNames = [];
                if (omitted == null || omitted.length == 0) {
                    effectiveFailedRuleNames = failedRuleNames;
                }
                else {
                    effectiveFailedRuleNames = failedRuleNames.filter(function (ruleName) { return !omitted.includes(ruleName); });
                }
                return effectiveFailedRuleNames.length > 0;
            }
        }
    };
    ValidationUtilities.isEmptyArray = function (array) {
        return array === undefined || array === null || array.length === 0;
    };
    return ValidationUtilities;
}());
export default ValidationUtilities;
